<template>
  <gg-card>
    <gg-card-header>
      <div class="d-flex align-center flex-wrap">
        <span class="mr-auto">{{ title }}</span>
        <!-- e.g. a Create button, for pages that keep the form out of view. -->
        <slot name="header-actions" />
      </div>
    </gg-card-header>
    <gg-card-text>
      <v-data-table :headers="headers" :items="responders.data" :loading="responders.loading_status">
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <gg-btn v-on="on" v-bind="attrs">
                Manage
                <v-icon>mdi-chevron-down</v-icon>
              </gg-btn>
            </template>
            <v-list>
              <v-list-item @click="editResponder(item.email)">
                <v-list-item-title>
                  Edit
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="deleteResponder(item.email)">
                <v-list-item-title>
                  Delete
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </gg-card-text>

    <delete-responder v-if="modals.delete" :is-active="modals.delete" action="edit" :email="email" @close="deleteResponder"/>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DeleteResponder from '@/components/Services/Hosting/Shared/Email/Autoresponders/Modals/DeleteModal'

export default {
  name: 'AutoresponderTable',
  components: {
    DeleteResponder
  },
  props: {
    title: {
      type: String,
      default: 'Manage Autoresponders Rules',
    },
  },
  data: () => ({
    headers: [
      {
        text: 'Email',
        value: 'email',
      },
      {
        text: 'Subject',
        value: 'subject',
      },
      {
        text: 'Actions',
        value: 'actions',
        sortable: false,
        align: 'center'
      },
    ],
    modals: {
      edit: false,
      delete: false
    },
    email: '',
    domain: ''
  }),
  methods: {
    ...mapActions({
      setResponders: 'email/setResponders',
      reportError: 'reportError'
    }),
    editResponder (email) {
      this.$emit('edit', {
        email,
        edit: true
      })
    },
    deleteResponder (email) {
      this.email = email
      this.modals.delete = !this.modals.delete
    }
  },
  computed: {
    ...mapGetters({
      responders: 'email/responders'
    })
  },
  mounted () {
    this.setResponders({
      domain: this.responders.domain,
      _username: this.$route.query.user,
    })
  },
}
</script>
